import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_SCC_API } from '@/service'
const api = {
  applyBasicInfo: PREFIX_SCC_API + 'fchild/appoint/addAppoint.do',
  cms4Collect: `${utils.hostname('cms')}/publish/999/collect.json`
}
export default {
  async saveCollectBasicInfo({ commit }, { info }) {
    try {
      const param = info
      const query = queryString.stringify(param)
      const info_res = await fetch(`${api.applyBasicInfo}?${query}`)
      const infoJSON = await info_res.json()
      return infoJSON
    } catch (e) {
      console.log(e)
    }
  },
  async getCmsConfig4Collect({ commit, state }) {
    try {
      const data_res = await fetch(`${api.cms4Collect}`)
      const dataJson = await data_res.json()
      commit('setSupportCollectCityList', dataJson.data.cityList || [])
      commit('setCollectSkuInfo', dataJson.data.sku)
      return dataJson
    } catch (e) {
      throw new Error(e)
    }
  }
}
